export default __webpack_public_path__ + "static/media/Banner2022_Salon-min.3a25902c.png";